
;(function(window, document, $) {
	$(document).ready(function() {

		var currentMediaQuery = utils._stateMediaQuery();

		//scroll to anchor nav
		$('.nav-sections').scrollToAnchor({
			showFrom: 820,
			scrollTopButton: true
		});
		//smoothscroll
		$('[data-type="smoothscroll"]').each(function() {
			if($(this).closest('.section-brand').length > 0) {
				SmoothScroll($(this),$('.nav-sections'));
			} else {
				SmoothScroll($(this),false,100);
			}
		});

		$(window).scroll(function() {
			if(!$('.scroll-top').hasClass('scrolled') && $(window).scrollTop() >= $(window).height()) {
				$('.scroll-top').addClass('scrolled');
			} else if ($('.scroll-top').hasClass('scrolled') && $(window).scrollTop() < $(window).height()) {
				$('.scroll-top').removeClass('scrolled');
			}
		});




/* Klantenservice FAQs */

var faqCounter = 0;

$('body.page-template-page_5 .content h4').each(function(index) {
	var answerId = 'answer-' + faqCounter.toString();

	var $answer = $(this).nextUntil('h2, h3, h4');

	$(this)
		.wrapInner('<a href="#' + answerId + '" data-type="dropdown"></div>')
		.wrap('<div class="faq-item"></div>')
		.after(
			$('<div class="faq-answer" id="' + answerId + '"></div>')
				.append($answer)
		);

	faqCounter++;
});





		//dropdown bind
		$('[data-type="dropdown"]').bind('click', function(e) {
			e.preventDefault();
			DropDown($(this));
		});

		//enable function select
		$('select#doelgroep').change(function() {
			if($(this).val() != '') {
				$('select#functie').attr('disabled', false);
			} else {
				$('select#functie').attr('disabled', true);
			}
		});

		//owl carousel
		$('.header-carousel').owlCarousel({
			items: 1,
			slideBy: 1,
			nav: true,
			navText: [],
			navContainer: '#header-carousel-nav',
			dots: false,
			loop: true,
			autoplay: true,
			autoplayTimeout: 4000,
			autoplayHoverPause: true,
			autoplaySpeed: 400
		});
		$('.magazine-carousel').owlCarousel({
			items: 4,
			nav: true,
			slideBy: 1,
			margin: 40,
			navText: [],
			navContainer: '#magazine-carousel-nav',
			dots: (currentMediaQuery == "mobile") ? false : true,
			dotsContainer: '#magazine-carousel-dots',
			responsive:{
				0:{
					items:1
				},
				400: {
					items: 2
				},
				600: {
					items: 3
				},
				800:{
					items: 4
				}
			}
		});
	});

	//FUNCTIONS
	//get mediaqueries
	utils = {
		_stateMediaQuery:function(){
			/*
			if(!$('.mediaIndicator').length) $('body').append('<div class="mediaIndicator"></div>');
			return window.getComputedStyle($('.mediaIndicator')[0], ':before').getPropertyValue('content').replace(/\"/g,'');
			*/
		}
	};

	//dropdown function
	function DropDown(elem) {
		//elem = element that triggered dropdown
		var trigger = elem;
		var nested = elem.data('nested');
		var target = elem.attr('href');

		$(trigger).removeClass('open');
		if($(target).hasClass('open')){
			$(target).slideUp(function(){
				$(target).removeAttr('style').removeClass('open');
				if(nested) trigger.parent().removeClass('open');
			});
		} else {
			$(trigger).addClass('open');
			$(target).slideDown(function(){
				$(target).removeAttr('style').addClass('open');
				if(nested) trigger.parent().addClass('open');
			});
		}
	}
	//smoothscroll
	function SmoothScroll(link, fixedMenuElem, spacing) {
		//link = link trigger
		//fixedMenuElem = false or jquery elem of fixed menu
		//spacing is extra spacing to top if desired

		//if fixed menu has to be taken in account
		var menuHeight = 0;
		if(fixedMenuElem.length) {
			menuHeight = fixedMenuElem.outerHeight();
		}
		if (spacing == null) { spacing = 0 };

		//link on click
		link.click(function(e) {
			var anchorId = link.attr('href');
			if ($(anchorId).length) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $(anchorId).offset().top - menuHeight - spacing
				});
			}
		});
	}
})(window, document, window.jQuery);
